import styled from "styled-components/macro";


const Input = styled.input`
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 4px;
  height: 56px;
  font-size: 14px;
  padding: 0 25px 0 25px;
`;

export default Input;
